// extracted by mini-css-extract-plugin
export var centerList = "_if-6";
export var centerLoc = "_if-a";
export var centerName = "_if-9";
export var centerOptionBody = "_if-8";
export var centerRow = "_if-7";
export var centerStatus = "_if-b";
export var empty = "_if-5";
export var externalIcon = "_if-c";
export var fieldHeader = "_if-2";
export var fieldHelp = "_if-4";
export var fieldLabel = "_if-3";
export var panel = "_if-0";
export var removeBtn = "_if-d";
export var section = "_if-1";